/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountPermissions_viewer$ref: FragmentReference;
declare export opaque type AccountPermissions_viewer$fragmentType: AccountPermissions_viewer$ref;
export type AccountPermissions_viewer = {|
  +accounts: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +vueexclusivepermissionSet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +vue: {|
                +id: string,
                +name: string,
              |},
            |}
          |}>
        |}
      |}
    |}>
  |},
  +$refType: AccountPermissions_viewer$ref,
|};
export type AccountPermissions_viewer$data = AccountPermissions_viewer;
export type AccountPermissions_viewer$key = {
  +$data?: AccountPermissions_viewer$data,
  +$fragmentRefs: AccountPermissions_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AccountPermissions_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "accountId",
      "type": "ID",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "accounts",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "accountId"
        }
      ],
      "concreteType": "AccountNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "AccountNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "AccountNode",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "vueexclusivepermissionSet",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "VueExclusivePermissionNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "VueExclusivePermissionNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "VueExclusivePermissionNode",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "vue",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "VueNode",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "name",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7fc70f1779d5549cb37ef4632ba84ba3';
module.exports = node;
